import { render } from "./ReportCriterionAutocomplete.vue?vue&type=template&id=36b7c266&scoped=true"
import script from "./ReportCriterionAutocomplete.vue?vue&type=script&lang=js"
export * from "./ReportCriterionAutocomplete.vue?vue&type=script&lang=js"

import "./ReportCriterionAutocomplete.vue?vue&type=style&index=0&id=36b7c266&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36b7c266"]])

export default __exports__